export default __webpack_public_path__ + "static/media/Tree2.999f4f3a.png";